import { getCountryName } from '@/ui/utils/localization-helpers/localization';

export type WithdrawalCountryOption = { value: string; label: string };

export function buildWithdrawalCountryOptions(
  codes: string[],
  language: string,
): WithdrawalCountryOption[] {
  return codes
    .map((code) => ({ value: code, label: getCountryName(code.toLowerCase(), language) }))
    .sort((a, b) => a.label.localeCompare(b.label, language));
}
